import {
  Invoice,
  InvoiceStatus,
  PayoutDestinationSummaryType,
  TaxWithholdingSettings
} from "@wingspanhq/wingspan-api-sdk";
import { selectorIsInvoicePaidOffPlatform } from "../../selectors/selectorIsInvoicePaidOffPlatform";

export const getInvoiceTaxWithholdings = (
  taxWithholdingSettings: TaxWithholdingSettings | undefined,
  invoice: Invoice,
  netIncome: number,
  hasActiveTaxWithholdingAccount: boolean
): {
  amount: number;
  rate: number;
} => {
  // The funds never passed through Wingspan, so nothing was withheld and
  // nothing can be. Projecting off the current rate would show the contractor a
  // deduction that does not exist, and move it every time they change the rate.
  if (selectorIsInvoicePaidOffPlatform(invoice)) {
    return { amount: 0, rate: 0 };
  }

  if (invoice.status === InvoiceStatus.PAID) {
    const amountWithheld = (invoice.payouts || [])
      .filter(
        payout =>
          payout.destination?.type ===
          PayoutDestinationSummaryType.TAX_WITHHOLDING
      )
      .reduce((total, payout) => total + payout.amount, 0);

    return {
      amount: amountWithheld,
      rate:
        invoice.taxWithholdingRate ??
        taxWithholdingSettings?.withholdingRate ??
        0
    };
  }

  const isActive =
    hasActiveTaxWithholdingAccount &&
    taxWithholdingSettings?.isEnabled === true;

  const defaultRate = isActive
    ? taxWithholdingSettings?.withholdingRate || 0
    : 0;

  return {
    amount: netIncome * (defaultRate / 100),
    rate: defaultRate
  };
};
